import {MULTI_SYNTH, SAMPLED_INSTRUMENT} from 'constants/instrument-types.js';
import {MULTI_FREEZE} from 'constants/track-types.js';

const DRUM_TAGS = new Set(['clap', 'tom', 'toms', 'clave', 'perc', 'snare', 'kick', 'hi-hat', 'rim', 'side-stick', 'breaks', 'sub', 'ride', 'piano', 'violin']);

export const getTrackName = (track) => {
    let sample = track.sample;
    let innerText = track.presetName || track.getName();
    if (sample && sample.tags) {
        innerText = sample.tags.find(tag => DRUM_TAGS.has(tag));
        if (!innerText) {
            innerText = sample.tags[0];
        }
    }
    if (track && track.getInstrumentType() == MULTI_SYNTH) {
        innerText = 'Synth';
    }
    if (track && track.getInstrumentType() === SAMPLED_INSTRUMENT) {
        let samples = track.instrument.getSamples();
        if (samples[0]) {
            innerText = samples[0].tags.find(tag => DRUM_TAGS.has(tag));
        }
    }

    return innerText;
};
